// Test IDs for the ICH landing page + auth + dashboard.

export const HOME = {
        emergentLink: 'home-emergent-link',
        navHome: 'nav-home',
        navAbout: 'nav-about',
        navServices: 'nav-services',
        navApproach: 'nav-consulting',
        navContact: 'nav-contact',
        navStudent: 'nav-student',
        navGetInTouch: 'nav-get-in-touch',
        navDashboard: 'nav-dashboard',
        navLogout: 'nav-logout',
        heroExploreCourses: 'hero-explore-courses',
        heroStartLearning: 'hero-start-learning',
        heroConsultation: 'hero-request-consultation',
        ctaExploreCourses: 'cta-explore-courses',
        ctaStartLearning: 'cta-start-learning',
        ctaConsultation: 'cta-request-consultation',
        founderPhoto: 'founder-photo',
        founderBio: 'founder-bio',
        serviceCard1: 'service-card-real-estate',
        serviceCard2: 'service-card-business',
        serviceCard3: 'service-card-digital-marketing',
        buyBtn: (id) => `buy-${id}`,
        enrollBtn: (id) => `enroll-${id}`,
        enrollIntentEmail: 'enroll-intent-email',
        enrollIntentName: 'enroll-intent-name',
        enrollIntentNote: 'enroll-intent-note',
        enrollIntentSubmit: 'enroll-intent-submit',
        contactEmail: 'contact-email',
        contactForm: 'contact-form',
        contactName: 'contact-name',
        contactEmailInput: 'contact-email-input',
        contactMessage: 'contact-message',
        contactSubmit: 'contact-submit',
        studentLoginSection: 'student-login-section',
        loginEmail: 'login-email',
        loginPassword: 'login-password',
        loginSubmit: 'login-submit',
        registerEmail: 'register-email',
        registerName: 'register-name',
        registerPassword: 'register-password',
        registerSubmit: 'register-submit',
        toggleAuthMode: 'toggle-auth-mode',
        dashboardRoot: 'dashboard-root',
        dashboardCourseCard: (id) => `dashboard-course-${id}`,
        dashboardOpenLesson: (id) => `dashboard-open-${id}`,
        lessonPlayer: 'lesson-player',
        lessonClose: 'lesson-close',
};
